import React from "react";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";

export interface StaleReportWarningProps {
  onRerunClick?: () => void;
}

function StaleReportWarning({ onRerunClick }: StaleReportWarningProps) {
  return (
    <Box mb={2}>
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={onRerunClick}>
            RERUN
          </Button>
        }
      >
        You&apos;ve made changes that affect this report. Rerun to see updated
        balances.
      </Alert>
    </Box>
  );
}

export default StaleReportWarning;
